import React, {Component} from 'react'
import {Control, Errors} from 'react-redux-form';
import {FormGroup, ControlLabel, Grid, Row, Col, Checkbox} from 'react-bootstrap';

import './styles.css'

class SMSMessage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      sms: false,
    };
  }

  setSMS = () => {
    this.setState({
      sms: !this.state.sms
    })
  };

  render() {
    return (
      <Grid bsClass="container" fluid className="editor">
        <Row>
          <Col md={12}>
            <FormGroup>
              <Control.checkbox model='.sms'
                                onChange={this.setSMS}
                                component={Checkbox} >
                SMS
              </Control.checkbox>
            </FormGroup>
            <FormGroup controlId="sms-body">
              <ControlLabel>Body*</ControlLabel>
              <Control.textarea
                model=".sms_body"
                rows="2"
                className="form-control"/>

              <Errors
                show={{
                  touched: true,
                  focus: false
                }}
                className="errors"
                model=".sms_body"/>
            </FormGroup>
          </Col>
        </Row>
      </Grid>
    );
  }
}

export default SMSMessage;


// WEBPACK FOOTER //
// ./src/components/admin/notifications/edit/sms-message-editor.jsx